import { render, staticRenderFns } from "./freezer-spec.vue?vue&type=template&id=686f8b21&scoped=true&"
import script from "./freezer-spec.vue?vue&type=script&lang=js&"
export * from "./freezer-spec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686f8b21",
  null
  
)

export default component.exports